export enum HeatmapStatus {
  INCREASED = 'INCREASED',
  DECREASED = 'DECREASED',
  DEFAULT = 'DEFAULT',
}

export const mockdata = [
  {
    name: 'cause1',
    symptoms: [
      {
        name: 'symptoms1',
        status: HeatmapStatus.INCREASED,
      },
      {
        name: 'symptoms2',
        status: HeatmapStatus.DEFAULT,
      },
      {
        name: 'symptoms3',
        status: HeatmapStatus.DEFAULT,
      },
      {
        name: 'symptoms4',
        status: HeatmapStatus.DECREASED,
      },
      {
        name: 'symptoms5',
        status: HeatmapStatus.INCREASED,
      },
      {
        name: 'symptoms6',
        status: HeatmapStatus.DECREASED,
      },
      {
        name: 'symptoms7',
        status: HeatmapStatus.INCREASED,
      },
    ],
  },
  {
    name: 'cause2',
    symptoms: [
      {
        name: 'symptoms1',
        status: HeatmapStatus.DEFAULT,
      },
      {
        name: 'symptoms2',
        status: HeatmapStatus.DEFAULT,
      },
      {
        name: 'symptoms3',
        status: HeatmapStatus.DECREASED,
      },
      {
        name: 'symptoms4',
        status: HeatmapStatus.DECREASED,
      },
      {
        name: 'symptoms5',
        status: HeatmapStatus.INCREASED,
      },
      {
        name: 'symptoms6',
        status: HeatmapStatus.DECREASED,
      },
      {
        name: 'symptoms7',
        status: HeatmapStatus.INCREASED,
      },
    ],
  },
  {
    name: 'cause1',
    symptoms: [
      {
        name: 'symptoms1',
        status: HeatmapStatus.INCREASED,
      },
      {
        name: 'symptoms2',
        status: HeatmapStatus.INCREASED,
      },
      {
        name: 'symptoms3',
        status: HeatmapStatus.DEFAULT,
      },
      {
        name: 'symptoms4',
        status: HeatmapStatus.DEFAULT,
      },
      {
        name: 'symptoms5',
        status: HeatmapStatus.INCREASED,
      },
      {
        name: 'symptoms6',
        status: HeatmapStatus.DECREASED,
      },
      {
        name: 'symptoms7',
        status: HeatmapStatus.INCREASED,
      },
    ],
  },
  {
    name: 'cause4',
    symptoms: [
      {
        name: 'symptoms1',
        status: HeatmapStatus.DECREASED,
      },
      {
        name: 'symptoms2',
        status: HeatmapStatus.DEFAULT,
      },
      {
        name: 'symptoms3',
        status: HeatmapStatus.DEFAULT,
      },
      {
        name: 'symptoms4',
        status: HeatmapStatus.DEFAULT,
      },
      {
        name: 'symptoms5',
        status: HeatmapStatus.INCREASED,
      },
      {
        name: 'symptoms6',
        status: HeatmapStatus.DECREASED,
      },
      {
        name: 'symptoms7',
        status: HeatmapStatus.INCREASED,
      },
    ],
  },
  {
    name: 'cause5',
    symptoms: [
      {
        name: 'symptoms1',
        status: HeatmapStatus.DEFAULT,
      },
      {
        name: 'symptoms2',
        status: HeatmapStatus.DEFAULT,
      },
      {
        name: 'symptoms3',
        status: HeatmapStatus.DECREASED,
      },
      {
        name: 'symptoms4',
        status: HeatmapStatus.INCREASED,
      },
      {
        name: 'symptoms5',
        status: HeatmapStatus.INCREASED,
      },
      {
        name: 'symptoms6',
        status: HeatmapStatus.DECREASED,
      },
      {
        name: 'symptoms7',
        status: HeatmapStatus.INCREASED,
      },
    ],
  },
];
